<template>
  <div class="button-row-container">
    <div class="button-wrapper">
      <key-capture
        @keydown="handleKeyDown"
      ></key-capture>
      <div
        v-if="showFlashcardStatuses"
        class="tag-wrapper"
      >
        <button
          v-for="status in answeredFlashcardStatuses"
          :key="status.id"
          class="button-choice"
          :data-test="`flashcard-status-${status.name}`"
          @click="tag(status.id)"
        >
          <icon
            name="tag-uui"
            :variant="status.name"
          ></icon>
          <span>{{ status.displayName }}</span>
        </button>
        <pop-over
          v-if="showChooseTagsPopover"
          use-circle
          icon-name="tag-uui-white"
        >
          <template #header>
            <span>Choose a tag to continue</span>
          </template>
          Tags can be used to sort and review questions later.
        </pop-over>
      </div>
      <button
        v-else
        class="button-choice"
        data-test="next-question-button"
        @click="tag(greenFlashcardStatus.id)"
      >
        {{ buttonText }}
      </button>
    </div>
  </div>
</template>

<script>
import Icon from '@/components/singletons/icon';
import KeyCapture from '@/components/singletons/KeyCapture';
import PopOver from '@/components/singletons/PopOver';

export default {
  components: {
    Icon,
    KeyCapture,
    PopOver,
  },
  props: {
    buttonText: {
      type: String,
      default: 'Next Question',
    },
    category: {
      type: Object,
      default: () => {},
    },
    flashcard: {
      type: Object,
      default: () => {},
    },
    showFlashcardStatuses: {
      type: Boolean,
      default: false,
    },
  },
  emits: ['tag'],
  computed: {
    answeredFlashcardStatuses() {
      return [...this.$store.getters['flashcardStatuses/answeredFlashcardStatuses']]
        .sort((a, b) => a.order - b.order);
    },
    greenFlashcardStatus() {
      return this.$store.getters['flashcardStatuses/greenFlashcardStatus'];
    },
    miraDrawerShown() {
      return this.$store.getters['ui/miraDrawerShown'];
    },
    showChooseTagsPopover() {
      return this.$store.getters['flashcardStates/flashcardStateList'].length === 0;
    },
  },
  methods: {
    tag(flashcardStatusId) {
      this.$emit('tag', flashcardStatusId);
    },
    handleKeyDown(key) {
      if (this.miraDrawerShown) return;
      if (key.length != 1) return;

      const matchingStatus = this.answeredFlashcardStatuses.find(
        status => status.displayName.toUpperCase()[0] === key.toUpperCase(),
      );
      if (matchingStatus) {
        this.tag(matchingStatus.id);
      }
  },
  },
};
</script>

<style lang="scss" scoped>
.button-row-container {
  position: fixed;
  left: 0;
  right: 0;
  bottom: 0;

  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: rem-calc(8);
  justify-content: center;
  padding: 1rem;
  background-color: #F9FAFB;
  z-index: 10;

  .button-wrapper {
    grid-column: 1 / 13;
    display: flex;
    flex-direction: row;
    justify-content: flex-end;
    align-items: center;
    gap: rem-calc(8);
    flex-grow: 1;
  }
  .tag-wrapper {
    position: relative;
    display: flex;
    gap: rem-calc(8);
  }

  .button-choice {
    background-color: white;
    border: 1px solid #e3e8ef;
    border-radius: rem-calc(6);
    color: #232323;
    // flex box properties
    display: flex;
    align-items: center;
    justify-content: center;
    gap: rem-calc(6);
    // text properties
    font-size: rem-calc(12);
    font-weight: 600;
    line-height: rem-calc(16);
    padding: rem-calc(8) rem-calc(8);
    white-space: nowrap;
    flex-grow: 1;
  }
}

@include breakpoint(tablet) {
  .button-row-container {
    left: rem-calc(88);
    bottom: 0;
    margin-bottom: 1rem;

    .button-wrapper {
      justify-content: center;
    }

    .button-choice {
      flex-grow: 0;
      justify-content: center;
      font-size: rem-calc(16);
      line-height: rem-calc(24);
      padding: rem-calc(8) rem-calc(16);
    }
  }
}

@include breakpoint(desktop) {
  .button-row-container {
    left: rem-calc(88);
    bottom: 0;
    display: grid;
    grid-template-columns: repeat(12, 1fr);
    gap: rem-calc(32);
    margin-right: 2rem;
    margin-left: 2rem;
    margin-bottom: 2rem;
    padding: 0;


    .button-wrapper {
      grid-column: 5 / 13;
    }

    .button-choice {
      flex-grow: 0;
      justify-content: center;
      font-size: rem-calc(16);
      line-height: rem-calc(24);
      padding: rem-calc(8) rem-calc(16);
    }
  }
}
</style>
